import React from "react";
import { Modal, Box, Typography, Button, CircularProgress, Divider } from "@mui/material";

const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
  minWidth: 320,
  maxWidth: 480,
  outline: "none",
};

const RefBox = ({ refId }) =>
  refId ? (
    <Box
      sx={{
        mt: 2,
        mb: 1,
        px: 2,
        py: 1.5,
        bgcolor: "#f5f5f5",
        borderRadius: "6px",
        border: "1px solid #e0e0e0",
      }}
    >
      <Typography variant="caption" color="text.secondary" display="block">
        Stripe Payment Reference ID
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, wordBreak: "break-all", mt: 0.5 }}
      >
        {refId}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Please save this for future reference.
      </Typography>
    </Box>
  ) : null;

const PaymentProcessingModal = ({ step, paymentRefId, onRetry }) => {
  const open =
    step === "processing" ||
    step === "invoicing" ||
    step === "invoice_failed";

  return (
    <Modal
      open={open}
      disableEscapeKeyDown
      onClose={() => {}}
      aria-labelledby="payment-processing-modal"
    >
      <Box sx={modalBoxStyle}>
        {step === "processing" && (
          <>
            <CircularProgress size={48} sx={{ mb: 2 }} />
            <Typography variant="h6" sx={{ mb: 1 }}>
              Processing your payment
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Please do not close or refresh this page.
            </Typography>
          </>
        )}

        {step === "invoicing" && (
          <>
            <CircularProgress size={48} sx={{ mb: 2 }} />
            <Typography variant="h6" sx={{ mb: 1 }}>
              Generating your invoice
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Your payment was successful. Preparing your invoice…
            </Typography>
            <RefBox refId={paymentRefId} />
          </>
        )}

        {step === "invoice_failed" && (
          <>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Invoice generation failed
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Your payment was successful but we could not generate your
              invoice. Please click retry or contact support with your reference
              number below.
            </Typography>
            <RefBox refId={paymentRefId} />
            <Divider sx={{ my: 2 }} />
            <Button variant="contained" onClick={onRetry}>
              Retry
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default PaymentProcessingModal;
